import _toConsumableArray from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import { weekDays } from "../../helpers/Date";
import providerApiService from "../../services/api/ProviderApiService";
import HourModal from "./HourModal.vue";
export default {
  name: "WorkingHours",
  components: {
    HourModal: HourModal
  },
  data: function data() {
    return {
      selectedTimespan: null,
      selectedDayIndex: null,
      hourModalVisibile: false,
      hourId: null,
      loading: false,
      hours: [{
        day: 1,
        hour: []
      }, {
        day: 2,
        hour: []
      }, {
        day: 3,
        hour: []
      }, {
        day: 4,
        hour: []
      }, {
        day: 5,
        hour: []
      }, {
        day: 6,
        hour: []
      }, {
        day: 7,
        hour: []
      }]
    };
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.loading = true;
      providerApiService.getProviderHours(this.currentProvider.id).then(function (result) {
        _this.hourId = result.id;

        for (var i = 0; i < _this.hours.length; i++) {
          for (var j = 0; j < result.details.length; j++) {
            if (_this.hours[i].day === result.details[j].day) {
              _this.hours[i].hour = result.details[j].hour;
            }
          }
        }
      }).finally(function () {
        return _this.loading = false;
      });
    },
    selectTimespan: function selectTimespan(item, index) {
      this.selectedTimespan = item; // Reset selectedTimespan for adding new timespan

      this.selectedDayIndex = index; // Assign selected day index

      this.toggleHourModalVisibility();
    },
    toggleHourModalVisibility: function toggleHourModalVisibility() {
      this.hourModalVisibile = !this.hourModalVisibile;
    },
    timeConfiremd: function timeConfiremd(hours, hourId) {
      this.toggleHourModalVisibility();
      this.hourId = hourId;
      this.hours[this.selectedDayIndex].hour = _toConsumableArray(hours);
    },
    getWeekDays: function getWeekDays(day) {
      return weekDays[day - 1];
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },
  destroyed: function destroyed() {},
  computed: mapGetters({
    currentProvider: "profile/currentProvider"
  })
};